import React, { useState } from 'react';
import { MapPin, Phone, Mail, CheckCircle, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import './Contact.css';

const services = [
  '安全运营服务', '渗透测试服务', '应急响应服务',
  '漏洞扫描服务', '代码审计服务', '资产测绘服务',
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', company: '', phone: '', email: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="contact-page-modern">
      {/* Background Decor */}
      <div className="contact-bg-glow shape-1"></div>
      <div className="contact-bg-glow shape-2"></div>
      
      <div className="container contact-container">
        <motion.div 
          className="contact-grid"
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          {/* Left Column: Info */}
          <motion.div className="contact-info-col" variants={fadeUp}>
            <div className="info-header">

              <h1 className="contact-title">
                准备好提升您的<br/>
                <span className="text-gradient">安全防御</span>了吗？
              </h1>
              <p className="contact-desc">
                我们的安全专家团队随时准备为您提供帮助。无论您是需要全面的安全评估，还是面临紧急的安全事件，请随时与我们联系。
              </p>
            </div>

            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon-wrap">
                  <Phone size={22} className="info-icon" />
                </div>
                <div className="info-text">
                  <h4>服务热线</h4>
                  <p className="info-val">400-xxx-xxxx</p>
                  <span className="info-sub">7×24小时值班服务</span>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon-wrap">
                  <Mail size={22} className="info-icon" />
                </div>
                <div className="info-text">
                  <h4>电子邮件</h4>
                  <p className="info-val">service@zzme.net</p>
                  <span className="info-sub">一般咨询与合作</span>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon-wrap">
                  <MapPin size={22} className="info-icon" />
                </div>
                <div className="info-text">
                  <h4>公司地址</h4>
                  <p className="info-val">吉林省长春市高新区中展万国城A10</p>
                  <span className="info-sub">欢迎预约上门拜访</span>
                </div>
              </div>
            </div>

            <div className="info-footer">
              <div className="promise-title">我们的服务承诺</div>
              <ul className="promise-list">
                <li><CheckCircle size={16} /> <span>15分钟内快速响应咨询</span></li>
                <li><CheckCircle size={16} /> <span>免费提供初级安全现状评估</span></li>
                <li><CheckCircle size={16} /> <span>严格签署并遵守保密协议</span></li>
              </ul>
            </div>
          </motion.div>

          {/* Right Column: Form */}
          <motion.div className="contact-form-col" variants={fadeUp}>
            <div className="form-glass-card">
              {submitted ? (
                <motion.div 
                  className="form-success-state"
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="success-icon-wrap">
                    <CheckCircle size={48} className="success-icon" />
                  </div>
                  <h3>提交成功！</h3>
                  <p>感谢您的信任。我们的安全顾问已收到您的信息，将在短时间内与您取得联系。</p>
                  <button className="btn btn-outline mt-4" onClick={() => setSubmitted(false)}>
                    返回重新填写
                  </button>
                </motion.div>
              ) : (
                <>
                  <div className="form-header">
                    <h3>在线留言</h3>
                    <p>填写下方表单，获取专属安全方案</p>
                  </div>
                  <form onSubmit={handleSubmit} className="modern-form">
                    <div className="form-row">
                      <div className="form-group">
                        <label>您的姓名 <span className="required">*</span></label>
                        <input
                          type="text"
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          placeholder="请输入您的称呼"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>联系电话 <span className="required">*</span></label>
                        <input
                          type="tel"
                          name="phone"
                          value={form.phone}
                          onChange={handleChange}
                          placeholder="我们将以此与您联系"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>公司名称</label>
                        <input
                          type="text"
                          name="company"
                          value={form.company}
                          onChange={handleChange}
                          placeholder="选填"
                        />
                      </div>
                      <div className="form-group">
                        <label>电子邮箱</label>
                        <input
                          type="email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          placeholder="选填"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label>感兴趣的服务</label>
                      <div className="custom-select-wrapper">
                        <select name="service" value={form.service} onChange={handleChange}>
                          <option value="" disabled>请选择服务类型</option>
                          {services.map((s) => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>咨询内容 <span className="required">*</span></label>
                      <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        placeholder="请简单描述您的安全需求、遇到的问题或合作意向..."
                        rows={4}
                        required
                      />
                    </div>

                    <button type="submit" className="submit-btn">
                      发送留言信息
                      <ArrowRight size={18} />
                    </button>
                  </form>
                </>
              )}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}